import {Injectable} from '@angular/core';
import {factory} from 'src/app/config/constants';
import {SelfPackageFactoryModel} from 'src/app/models/self-package/self-package-factory.model';
import {RuleMessageModel} from '../models/select-plans/rule-message.model';
import {SelfPackageModel} from "../models/save-model/self-package-model";
import {ProductModel} from "../models/select-plans/product-personal-accident.model";
import {PlanGroupRiderModel} from "../models/select-plans/product-rider.model";

@Injectable()
export class SelfPackageFactoryService {

  constructor() { }

  getSelfPackage(): SelfPackageFactoryModel {
    return JSON.parse(sessionStorage.getItem(factory.selfPackage));
  }

  setSelfPackage(selfPackage: SelfPackageFactoryModel) {
    sessionStorage.setItem(factory.selfPackage, JSON.stringify(selfPackage));
  }

  getSelfPackageId(): string {
    return JSON.parse(sessionStorage.getItem(factory.selfPackageId));
  }

  setSelfPackageId(selfPackageId: string) {
    sessionStorage.setItem(factory.selfPackageId, selfPackageId);
  }

  setQuotationInfo(quotationInfo: SelfPackageModel) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.quotationInfo = quotationInfo;
    this.setSelfPackage(selfPackage);
  }

  removeSelfPackageId() {
    sessionStorage.removeItem(factory.selfPackageId);
  }

  removeSelfPackage() {
    sessionStorage.removeItem(factory.selfPackage);
  }

  removeSelfPackageInsurance() {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.insurancePlan = new ProductModel();
    selfPackage.riderPlan = new Array<PlanGroupRiderModel>();
    this.setSelfPackage(selfPackage);
  }

  getTotalSumCowrie(): any {
    const plan = this.getSelfPackageOrNew();
    if (plan) {
      return plan.totalSumCowrie;
    }
    return 0;
  }

  setTab(tab: string) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.tab = tab;
    this.setSelfPackage(selfPackage);
  }

  setInsurancePlan(insurancePlan: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.insurancePlan = insurancePlan;
    this.setSelfPackage(selfPackage);
  }

  setExtraPlan(riderPlan: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.riderPlan = riderPlan;
    this.setSelfPackage(selfPackage);
  }

  setInsurancePlanOld(insurancePlan: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.insurancePlanOld = insurancePlan;
    this.setSelfPackage(selfPackage);
  }

  setExtraPlanOld(riderPlan: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.riderPlanOld = riderPlan;
    this.setSelfPackage(selfPackage);
  }

  setPersonalPlan(personalPlan: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.personalPlan = personalPlan;
    this.setSelfPackage(selfPackage);
  }

  setPersonalMemberPlan(personalMemberPlan: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.personalMemberPlan = personalMemberPlan;
    this.setSelfPackage(selfPackage);
  }

  setPersonalMemberInfo(personalMemberInfo: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.personalMemberInfo = personalMemberInfo;
    this.setSelfPackage(selfPackage);
  }

  setSelfPackageInfo(selfPackageInfo: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.selfPackageInfo = selfPackageInfo;
    this.setSelfPackage(selfPackage);
  }

  setSumCowrieExtra(sumCowrieExtra: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.sumCowrieExtra = sumCowrieExtra;
    this.setSelfPackage(selfPackage);
  }

  setTotalSumCowrie(value: any) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.totalSumCowrie = value;
    this.setSelfPackage(selfPackage);
  }

  setWarningMessage(warningMessage: Array<RuleMessageModel>) {
    const selfPackage = this.getSelfPackageOrNew();
    selfPackage.isWarning = true;
    selfPackage.warningMessage = warningMessage;
    this.setSelfPackage(selfPackage);
  }

  private getSelfPackageOrNew(): SelfPackageFactoryModel {
    const selfPackage = this.getSelfPackage();
    if (selfPackage) {
      return selfPackage;
    }
    return new SelfPackageFactoryModel();
  }
}
